/** UI copy for the shared base/form components. Shared labels (Cancel…) live in `COMMON_TEXT`. */
export const SHARED_COMPONENTS_TEXT = {
  confirm: {
    header: 'Please confirm',
    accept: 'Yes',
  },
  datePicker: {
    placeholder: 'MM-DD-YYYY',
  },
  spinner: {
    loading: 'Loading',
  },
  filePicker: {
    attachFiles: 'Attach files',
    noFileChosen: 'No file chosen',
    filesChosen: (count: number) => `${count} files chosen`,
    removeChosen: 'Remove chosen files',
  },
  table: {
    empty: 'Nothing to show.',
    rowsPerPage: 'Rows per page',
  },
} as const;
